
    import './styles.scoped.css';
    export default {
  "drawer-displayed": "awsui_drawer-displayed_1lh3u_8pwh8_9",
  "drawer-content": "awsui_drawer-content_1lh3u_8pwh8_13"
};
  